export const includes = 
`
    to receive-packet
        if (is-defined '_packet-length') = false
        [
            make '_packet-length' 6
        ]



        make '_checksum' 0

        make '_packet-type' 'T1'
        ;always T1 right now because these aren't defined yet

        let "i 0
        make '_last-packet' :_packet-type
        make "_last-packet se :_last-packet now
        make "_last-packet se :_last-packet :_packet-length

        repeat ( :_packet-length ) [
            let "_adc-holder readADC :i
            make "_last-packet se :_last-packet ( :_adc-holder )
            let 'i' :i + 1
            make "_checksum :_checksum + (:_adc-holder)
        ]

        make "_last-packet se :_last-packet :_checksum

        if (is-defined '_packet-log') = false 
        [
            make '_packet-log' false
        ]

       if (:_packet-log = true)[
            logData :_last-packet
        ]

    end

    to ReceivePacket 
        if (is-defined '_packet-length') = false
        [
            make '_packet-length' 6
        ]
        
        make '_checksum' 0

        let "i 0
        let "date_time getDateTime
        let "date nth 0 :date_time
        let "time nth 1 :date_time
        let "unix_time now ;in seconds, changed from milliseconds

        make '_last-packet' :date
        make "_last-packet se :_last-packet :time
        make "_last-packet se :_last-packet :unix_time

        repeat ( :_packet-length ) [
            let "done false
            
            ;recieve values as ADC units
            if (:i < 6) [ ;I'm not sure why I set this to 6, 4 would probably make more sense based on the cases below
                let "_adc-holder readADC :i
            ]

            ;Case check for lux and celcius conversion
            if (:i = 0 or :i = 4) [
                let "_lux ConvertToLux :_adc-holder
                make "_last-packet se :_last-packet ( round :_lux )
                let "done true
            ]
            if (:i > 0 and :i < 4) [
                ;Celcius
                let "_celcius round (0.5348 * (:_adc-holder - 148.6)) + 13
                make "_last-packet se :_last-packet ( :_celcius )
                let "done true
            ]
            if (:i = 5) [ ;just grab adc value
                make "_last-packet se :_last-packet ( :_adc-holder )
                let "done true
            ]
                
            if (:done = false)[ make "_last-packet se :_last-packet ( :_adc-holder ) ]
            let 'i' :i + 1
            make "_checksum :_checksum + (:_adc-holder)
        ]

        ;Check if the packet is being logged
        if (is-defined '_packet-log') = false 
        [
            make '_packet-log' false
        ]
        if (:_packet-log = true)[
            logData :_last-packet
        ]
    end


    to RecieveMotionPacket      
        _packetSetup ;sets up date, time, deltatime
        
        set-packet-count 6
        set-packet-save true

        make '_last-packet' :date
        make "_last-packet se :_last-packet :time
        make "_last-packet se :_last-packet :unix_time

        make "_last-packet se :_last-packet readPing
        make "_last-packet se :_last-packet readVel
        ;make "_last-packet se :_last-packet readAccel

        print :_last-packet

        _logCheck ;checks if the packet is being logged
    end


    to _packetSetup
        if (is-defined '_packet-length') = false
        [
            make '_packet-length' 6
        ]
        
        make '_checksum' 0

        make "i 0
        make "date_time getDateTime
        make "date nth 0 :date_time
        make "time nth 1 :date_time
        make "unix_time NowMilli

        make '_last-packet' :date
        make "_last-packet se :_last-packet :time
        make "_last-packet se :_last-packet :unix_time
    end

    to _logCheck
        ;Check if the packet is being logged
        if (is-defined '_packet-log') = false 
        [
            make '_packet-log' false
        ]
        if (:_packet-log = true)[
            logData :_last-packet
        ]
    end



    to recievePacketInCelcius
        make '_packet-length' 6
        make '_checksum' 0

        make '_packet-type' 'T1'
        ;always T1 right now because these aren't defined yet

        let "i 0
        make '_last-packet' :_packet-type
        make "_last-packet se :_last-packet now
        make "_last-packet se :_last-packet :_packet-length

        repeat ( :_packet-length ) [
            let "_adc-holder readADC :i
            ADUtoCelcius :_adc-holder
            let "x readADUAsCelcius :i
            print 'ADU: '
            print :x
            let "_adc-holder :output
            make "_last-packet se :_last-packet ( :_adc-holder )
            let 'i' :i + 1
            make "_checksum :_checksum + (:_adc-holder)
        ]

        make "_last-packet se :_last-packet :_checksum

        if (is-defined '_packet-log') = false 
        [
            make '_packet-log' false
        ]

       if (:_packet-log = true)[
            logData :_last-packet
        ]
    
    end

    to GetTempADCs
        make "adcList []
        push "adcList readADC1
        push "adcList readADC2
        push "adcList readADC3
        print :adcList
    end

    to CalibrateTempSensor :adcVal :sensorNum
        if (:sensorNum = 1) [
            ifelse (is-defined "slope1) [	
                let "temp :slope1 * :adcVal + :b1
                return round :temp
            ][print 'Sensor 1 not calibrated']
        ]
        if (:sensorNum = 2) [
             ifelse (is-defined "slope2) [
                let "temp :slope2 * :adcVal + :b2
                return round :temp
            ][print 'Sensor 2 not calibrated']
        ]
        if (:sensorNum = 3) [
            ifelse (is-defined "slope3) [    
                let "temp :slope3 * :adcVal + :b3
                return round :temp
            ][print 'Sensor 3 not calibrated']
        ]
        
        return :adcVal
    end

    to CalibrationSetup :adcLow :tmpLow :adcHigh :tmpHigh :sensorNum  
        let "slope (:tmpHigh - :tmpLow) / (:adcHigh - :adcLow)
        let "b :tmpLow - (:slope * :adcLow)

        if (:sensorNum = 1) [
            make "slope1 :slope
            make "b1 :b
        ]
        if (:sensorNum = 2) [
            make "slope2 :slope
            make "b2 :b
        ]
        if (:sensorNum = 3) [
            make "slope3 :slope
            make "b3 :b
        ]
    end

    to ConvertToLux :adu
        let "_lux (4.2866 * :adu) - 2.6713
        if :_lux < 0 [make "_lux 0]
        return :_lux
    end

    to LuxConversion :adc
        let "lux round (4.2866 * :adc) - 2.6713

        if (:lux < 0)[ return 0 ]
        return :lux
    end

    to ADUtoCelcius :adu
        make "output ( :adu * 5 ) / 1024.9
        make "output ( :output - 0.5 ) * 100
    end

    to set-packet-count :n
        make '_packet-length' :n
    end

    to set-packet-save :value
        make '_packet-log' :value
    end

    to set-packet-mode :mode
        make '_packet-mode' :mode
    end

    to readLightSensor
        output readADC2
    end

    to readTempSensor0
        output readADC0
    end

    to readTempSensor1
        output readADC1
    end

    to readTempSensor2
        output readADC2
    end

    to showxy
        print tcor
    end




`;
